module.exports = __webpack_public_path__ + "media/WR Blob 8.584ce1a7.mp3";